import WalletIcon from 'assets/svg/app/wallet.svg'
import { FlexDivRowCentered } from 'components/layout/flex'
import { FlexDivCol } from 'components/layout/flex'
import { DEFAULT_PERPS_PROVIDER } from 'constants/futures'
import ROUTES from 'constants/routes'
import Connector from 'containers/Connector'
import { useRouter } from 'next/router'
import { memo, useCallback } from 'react'
import { setOpenModal } from 'state/app/reducer'
import { useAppDispatch } from 'state/hooks'
import styled from 'styled-components'
import media from 'styles/media'
import Menu from '../AppLayout/Header/Nav/Menu'
import Logo from '../Logo'
import MarketsMarquee from './MarketsMarquee'

const MobileHeader = memo(({ marketsMarquee = true }: { marketsMarquee?: boolean }) => {
	const router = useRouter()
	const { login, isWalletConnected } = Connector.useContainer()
	const dispatch = useAppDispatch()
	const handleConnect = useCallback(() => {
		if (isWalletConnected) {
			dispatch(setOpenModal('manage_wallet'))
		} else {
			login()
		}
	}, [login, isWalletConnected, dispatch])

	return (
		<StickyContainer>
			<Container $bottomBorder={marketsMarquee}>
				<Menu />
				<LogoContainer onClick={() => router.push(ROUTES.Markets.Home(DEFAULT_PERPS_PROVIDER))}>
					<Logo />
				</LogoContainer>
				<IconWrapper onClick={handleConnect}>
					<WalletIcon width={20} height={20} />
				</IconWrapper>
			</Container>
			{marketsMarquee && <MarketsMarquee />}
		</StickyContainer>
	)
})

const IconWrapper = styled.nav`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 5px;
	border: 1px solid ${(props) => props.theme.colors.selectedTheme.newTheme.border.color};
`

const StickyContainer = styled(FlexDivCol)`
	position: sticky;
	top: 0;
	z-index: 50;
	width: 100%;
	border-bottom: 1px solid${(props) => props.theme.colors.selectedTheme.newTheme.border.color};
	background: ${(props) => props.theme.colors.selectedTheme.newTheme.containers.cards.background};
`

const Container = styled(FlexDivRowCentered)<{ $bottomBorder?: boolean }>`
	height: 60px;
	width: 100%;
	padding: 10px 40px;
	border-bottom: ${(props) => (props.$bottomBorder ? `1px solid ${props.theme.colors.selectedTheme.newTheme.border.color}` : 'none')};
	${media.lessThan('lg')`
		margin: auto;
		padding: 12px 16px;
	`}
`

const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	& span {
		width: 125px;
	}
	${media.lessThan('lg')`
		& span {
			width: 120px;
		}
  	`}
`

export default MobileHeader
